import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Clock, MapPin } from 'lucide-react';
export function Programs() {
  const [activeTab, setActiveTab] = useState<'monthly' | 'annual'>('monthly');
  const monthlyPrograms = [{
    title: 'NIWALE (Night Watchers Legislation)',
    schedule: '1st–5th every month',
    time: '9:00 PM daily',
    type: 'Prayer Meeting'
  }, {
    title: 'SPA (Supernatural & Prophetic Activations)',
    schedule: '11th every month',
    time: '9:00 PM',
    type: 'Activation'
  }, {
    title: 'NWC (New Wine Conference)',
    schedule: '15th–16th every month',
    time: '8:00 PM daily',
    type: 'Conference'
  }];
  const annualPrograms = [{
    title: 'Market Outreach',
    date: 'January',
    location: 'Local Markets'
  }, {
    title: 'Hospital Outreach',
    date: 'March',
    location: 'Hospitals'
  }, {
    title: 'Orphanage Outreach',
    date: 'May & December',
    location: 'Orphanages'
  }, {
    title: 'MYPR (Mid-Year Prayer Retreat)',
    date: 'June',
    location: 'Retreat Center'
  }, {
    title: 'Correctional Center Outreach (CCO)',
    date: 'August',
    location: 'Correctional Centers'
  }, {
    title: 'Village Outreach',
    date: 'October',
    location: 'Villages'
  }, {
    title: '10 Nights of Lambano',
    date: 'December',
    location: 'Online/In-person'
  }, {
    title: 'EOYPR (End-of-Year Prayer Retreat)',
    date: 'December',
    location: 'Retreat Camp'
  }];
  return <section id="programs" className="py-32 bg-ivory text-midnight" data-id="element-301">
      <div className="max-w-7xl mx-auto px-6" data-id="element-302">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-303">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 text-midnight rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-304">
            2026 Calendar
          </div>
          <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-12" data-id="element-305">
            Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-306">
              Programs
            </span>
          </h3>

          <div className="relative flex p-1.5 bg-midnight/5 rounded-full" data-id="element-307">
            <button onClick={() => setActiveTab('monthly')} className={`relative z-10 px-8 py-3 rounded-full text-sm font-bold tracking-wide transition-colors ${activeTab === 'monthly' ? 'text-ivory' : 'text-midnight hover:text-midnight/70'}`} data-id="element-308">
              Recurring Monthly
            </button>
            <button onClick={() => setActiveTab('annual')} className={`relative z-10 px-8 py-3 rounded-full text-sm font-bold tracking-wide transition-colors ${activeTab === 'annual' ? 'text-ivory' : 'text-midnight hover:text-midnight/70'}`} data-id="element-309">
              Annual Outreaches
            </button>

            {/* Animated Pill Indicator */}
            <div className="absolute inset-1.5 pointer-events-none flex" data-id="element-310">
              <motion.div className="h-full bg-midnight rounded-full" initial={false} animate={{
              width: '50%',
              x: activeTab === 'monthly' ? '0%' : '100%'
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-311" />
            </div>
          </div>
        </div>

        <div className="min-h-[400px]" data-id="element-312">
          <AnimatePresence mode="wait" data-id="element-313">
            {activeTab === 'monthly' ? <motion.div key="monthly" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="grid md:grid-cols-3 gap-6" data-id="element-314">
                {monthlyPrograms.map((prog, idx) => <div key={idx} className="bg-white p-8 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-315">
                    <div className="inline-flex items-center px-3 py-1 bg-gold/10 text-gold rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-316">
                      {prog.type}
                    </div>
                    <h4 className="text-2xl font-display font-bold text-midnight mb-8 leading-tight" data-id="element-317">
                      {prog.title}
                    </h4>
                    <div className="space-y-4" data-id="element-318">
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-319">
                        <div className="w-8 h-8 rounded-full bg-midnight/5 flex items-center justify-center text-midnight group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-320">
                          <Calendar className="w-4 h-4" data-id="element-321" />
                        </div>
                        <span data-id="element-322">{prog.schedule}</span>
                      </div>
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-323">
                        <div className="w-8 h-8 rounded-full bg-midnight/5 flex items-center justify-center text-midnight group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-324">
                          <Clock className="w-4 h-4" data-id="element-325" />
                        </div>
                        <span data-id="element-326">{prog.time}</span>
                      </div>
                    </div>
                  </div>)}
              </motion.div> : <motion.div key="annual" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.3
          }} className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-327">
                {annualPrograms.map((prog, idx) => <div key={idx} className="bg-white p-6 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-328">
                    <h4 className="text-xl font-display font-bold text-midnight mb-6 leading-tight h-14" data-id="element-329">
                      {prog.title}
                    </h4>
                    <div className="space-y-3" data-id="element-330">
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-331">
                        <div className="w-7 h-7 rounded-full bg-midnight/5 flex items-center justify-center text-midnight shrink-0 group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-332">
                          <Calendar className="w-3.5 h-3.5" data-id="element-333" />
                        </div>
                        <span data-id="element-334">{prog.date}</span>
                      </div>
                      <div className="flex items-center gap-3 text-sm font-medium text-charcoal/80" data-id="element-335">
                        <div className="w-7 h-7 rounded-full bg-midnight/5 flex items-center justify-center text-midnight shrink-0 group-hover:bg-gold group-hover:text-white transition-colors" data-id="element-336">
                          <MapPin className="w-3.5 h-3.5" data-id="element-337" />
                        </div>
                        <span className="truncate" data-id="element-338">{prog.location}</span>
                      </div>
                    </div>
                  </div>)}
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}